import React from 'react'

const BADGES = {
  'MANUAL NEW': {
    label: 'M. Daftar Baru',
    bgColor: '#DFE1E6',
    textColor: '#42526E',
  },
  'MANUAL RENEW': {
    label: 'M. Pembaruan',
    bgColor: '#DFE1E6',
    textColor: '#42526E',
  },
  ACTIVE: {
    label: 'Anggota Aktif',
    bgColor: '#FFF0B3',
    textColor: '#A95E27',
  },
  NEW: {
    label: 'Daftar Baru',
    bgColor: '#DEEBFF',
    textColor: '#0747A6',
  },
  RENEW: {
    label: 'Pembaruan',
    bgColor: '#E3FCEF',
    textColor: '#006644',
  },
}

const TypeBadge = ({ type }) => {
  return (
    <div
      className="inline-flex items-center justify-center rounded-full py-1 px-2.5 text-[13px] font-medium whitespace-nowrap"
      style={{
        backgroundColor: BADGES[type?.toUpperCase()]?.bgColor,
        color: BADGES[type?.toUpperCase()]?.textColor,
      }}
    >
      {BADGES[type?.toUpperCase()]?.label}
    </div>
  )
}

export default TypeBadge
